import { render } from "./TitleText.vue?vue&type=template&id=5d866848&scoped=true&ts=true"
import script from "./TitleText.vue?vue&type=script&lang=ts"
export * from "./TitleText.vue?vue&type=script&lang=ts"

import "./TitleText.vue?vue&type=style&index=0&id=5d866848&scoped=true&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d866848"]])

export default __exports__